'use client';

import { cn } from '~/lib/utils';
import { typography } from '~/components/Typography';

type FieldSectionProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
};

export default function FieldSection({ title, children, className, action }: FieldSectionProps) {
  return (
    <section className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between gap-2">
        <h3 className={typography.section}>{title}</h3>
        {action}
      </div>
      <div>{children}</div>
    </section>
  );
}
